import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Cell from './Cell'
import fillNullCashflowData from './helpers/fillNullCashflowData'

const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(5, 1fr);
  padding: 10px 10px 10px 0px;
  font-weight: bold;
`
const Title = styled.div`
  text-align: right;
  flex-grow: 2;
  flex-basis: 0;
  max-width: 90%;
  justify-self: end;
`

export default class SegmentFooter extends React.Component {
  renderCells = () => {
    const { data, years, isEditable, resourceType, entity, fiscalYears } = this.props
    return fillNullCashflowData(data, years).map(datum => {
      const fiscalYear = fiscalYears.find(y => y.year === datum.year)
      const { period, annualizationCoefficient } = fiscalYear
      const { source, data, year, category } = datum
      return (
        <Cell
          key={`${year}-${category}`}
          data={data}
          isTableEditable={isEditable}
          resourceType={resourceType}
          source={source}
          period={period}
          entity={entity}
          annualizationCoefficient={annualizationCoefficient}
        />
      )
    })
  }
  render() {
    const { title } = this.props
    return (
      <Container>
        <Title>{title}</Title>
        {this.renderCells()}
      </Container>
    )
  }
}

SegmentFooter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string
}